export default __webpack_public_path__ + "static/thebottomline21-302bbbeb683bf7c0155e5df564c9148d.jpg";